import { render } from "./AutoLogin.vue?vue&type=template&id=2a1ebe48"
import script from "./AutoLogin.vue?vue&type=script&lang=js"
export * from "./AutoLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__